<template>
    <span class="oneRootNode">
        <PopupAlert v-if="enablePopupAlert" />

        <div
            class="container-fluid fixed-top"
            id="header_small"
            v-if="showSmallHeader"
        >
            <div class="row justify-content-center no-gutters">
                <div class="col col-12 col-md-11">
                    <div class="row">
                        <div class="col col-12 col-lg-9 offset-lg-3  header_small_inner">
                            <slot name="header_small"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="container-fluid"
            ref="toprow"
            :class="{ 'has-backroute': !!this.$slots.back }"
        >
            <div class="row justify-content-center">
                <div class="col col-12 col-md-11">
                    <div class="row">
                        <div class="d-none d-lg-block col col-3">
                            <div class="left_menu_inner_sticky">
                                <Logo class="menu_logo"
                                    v-on="logoOnClick ? {click: logoOnClick} : {}"
                                    :class="{clickable: logoOnClick}"
                                />

                                <div id="back-button">
                                    <slot name="back"></slot>
                                </div>

                                <slot name="menu"></slot>
                            </div>
                        </div>

                        <div class="col col-12 col-lg-9">
                            <div class="row justify-content-end">
                                <div
                                    id="header"
                                    class="col col-12"
                                    :class="{
                                        'has-breadcrumbs': !!this.$slots
                                            .breadcrumbs,
                                    }"
                                >
                                    <div id="breadcrumbs">
                                        <slot name="breadcrumbs"></slot>
                                    </div>

                                    <slot name="header"></slot>
                                </div>

                                <div class="col col-12">
                                    <slot name="content"></slot>

                                    <Footer v-if="showFooter" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
import Logo from "@/components/Logo.vue";
import PopupAlert from "@/components/PopupAlert.vue";
import Footer from "@/components/Footer.vue"

export default {
    props: {
        enablePopupAlert: { type: Boolean, default: true },
        logoOnClick: {type: Function},
        showFooter: {type: Boolean, default: false}
    },
    name: "detail-layout",
    data: function () {
        return {
            topRowHeight: 0,
            showSmallHeader: false,
            headerHeight:null,
            currentScrollPosition: 0,
        };
    },
    components: { Logo, PopupAlert, Footer },
    created() {
    },
    mounted: function () {
        window.addEventListener("scroll", this.onScroll);
    },
    methods: {
        onScroll() {
            if(this.headerHeight!=null){

                this.currentScrollPosition =
                    window.pageYOffset || document.documentElement.scrollTop;
                if (this.currentScrollPosition < this.headerHeight) {
                    this.showSmallHeader = false;
                } else {
                    this.showSmallHeader = true;
                }
            }
            else{
                this.headerHeight=document.getElementById("header").offsetHeight;
            }
        }
    }
};
</script>

<style lang="scss">
@import "src/scss/custom";

#header_small {
    z-index: 1000;
}

.header_small_inner {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: white;
    border-bottom: 1px dotted $table-border-color;
}

#header {
    margin-top: 40px;
    margin-bottom: 40px;

    &.has-breadcrumbs {
        margin-top: 0px;
        margin-bottom: 35px;
    }
}

#header h1 {
    margin-bottom: 0px;
}

#header h3 {
    margin-bottom: 0px;
}

#header_small h2 {
    margin-bottom: 0px;
    display: inline-block;
    font-size: 24px;
}

#header_small h3 {
    margin-bottom: 0px;
    display: inline-block;
}

#period,
#suppliers {
    text-align: right;
}

#period h1,
#suppliers h1 {
    font-family: $monospace-font-family;
    font-weight: 700;
    font-size: 32px;
    @media (max-width: 575.98px) {
        font-size: 24px;
    }
}

.redflags-logo {
    margin-bottom: 120px;
    margin-top: 40px;
}

.has-backroute .redflags-logo {
    margin-bottom: 40px;
}

.menu_logo {
    padding-left: 1.5rem;
    padding-top: 10px;
}

#back-button > * {
    background-color: $background-light;
    font-size: 15px;
    font-weight: bold;
    border-radius: 8px;
    padding: 15px 20px;
    height: 50px;
    line-height: 14px;
    margin-bottom: 40px;
}

#breadcrumbs > * {
    color: #9b9b9b;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    margin-bottom: 30px;

    a {
        color: #9b9b9b;
        text-decoration: underline;

        &:hover {
            color: #9b9b9b;
            text-decoration: none;
        }
    }
}

.left_menu_inner_sticky {
    position: sticky;
    top: 0;
    z-index: 1050;
}
</style>
